import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import * as antd from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'

const RegisterCompletePage = () => {
	const navigate = useNavigate()

	return (
		<CompleteContainer>
			<CompleteCard>
				<SuccessIcon>
					<CheckCircleOutlined />
				</SuccessIcon>
				<Title>회원가입이 완료되었습니다</Title>
				<Message>
					관리자의 승인 후 사용 가능합니다.<br />
					승인 완료 시 이메일로 알려드리겠습니다.
				</Message>
				<InfoBox>
					<InfoTitle>다음 단계</InfoTitle>
					<InfoList>
						<li>관리자가 가입 정보를 검토합니다 (1-2일 소요)</li>
						<li>승인 완료 후 이메일로 안내드립니다</li>
						<li>이메일 안내 후 로그인하여 서비스를 이용하세요</li>
					</InfoList>
				</InfoBox>
				<ButtonGroup>
					<antd.Button
						type="primary"
						size="large"
						onClick={() => navigate('/admin/login')}
						style={{ background: '#800020', borderColor: '#800020' }}
					>
						로그인 페이지로 이동
					</antd.Button>
					<antd.Button
						size="large"
						onClick={() => navigate('/register')}
					>
						홈으로 돌아가기
					</antd.Button>
				</ButtonGroup>
			</CompleteCard>
		</CompleteContainer>
	)
}

const CompleteContainer = styled.div`
	min-height: 100vh;
	background: linear-gradient(135deg, #800020 0%, #a03040 100%);
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 40px 20px;
`

const CompleteCard = styled.div`
	background: white;
	padding: 64px 48px;
	border-radius: 16px;
	width: 100%;
	max-width: 560px;
	text-align: center;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`

const SuccessIcon = styled.div`
	font-size: 80px;
	color: #52c41a;
	margin-bottom: 24px;
`

const Title = styled.h1`
	font-size: 28px;
	font-weight: 600;
	color: #333;
	margin-bottom: 16px;
`

const Message = styled.p`
	font-size: 16px;
	line-height: 1.6;
	color: #666;
	margin-bottom: 32px;
`

const InfoBox = styled.div`
	background: #f8f9fa;
	padding: 24px;
	border-radius: 12px;
	margin-bottom: 32px;
	text-align: left;
`

const InfoTitle = styled.h3`
	font-size: 16px;
	font-weight: 600;
	color: #333;
	margin-bottom: 12px;
`

const InfoList = styled.ul`
	margin: 0;
	padding-left: 20px;
	color: #666;
	font-size: 14px;
	line-height: 1.8;
`

const ButtonGroup = styled.div`
	display: flex;
	gap: 16px;
	justify-content: center;
	flex-wrap: wrap;
`

export default RegisterCompletePage
